angular.module('impactx.smartform').controller('SFTListCtrl', SFTListCtrl);

SFTListCtrl.$inject = ['selectedListItems', '$mdDialog', 'TranslationService', 'dataGen', 'ToastService', '$redirect', '$route'];

function SFTListCtrl(selectedListItems, $mdDialog, TranslationService, dataGen, ToastService, $redirect, $route)
{
    this.getDetailLink = function() {
        return "sfteditor/"+selectedListItems.getFirstSelectedId()
    };

    this.copyDialog = function(event, trns) {
        var prompt = $mdDialog.prompt()
            .title(trns.identifierTitle)
            .textContent(trns.identifierContent)
            .placeholder(trns.identifierPlaceholder)
            .required(true)
            .ok(TranslationService.get('ok'))
            .cancel(TranslationService.get('abort'));
        $mdDialog.show(prompt).then(function (result) {
            dataGen.postAsForm({}, {id: selectedListItems.getFirstSelectedId(), identifier: result}, "/smartform/copy")
                .then(function(response) {
                    $redirect.redirectTo(null, "/sfteditor/" + response.data.id);
                    ToastService.openStandardToast(response.trns.copySuccess);
                });
        });
    }

    this.rename = function(ev, trns) {
        const selected = JSON.parse(JSON.stringify(selectedListItems.getFirstSelectedItem()));
        $mdDialog.show({
            controller: 'RenameSFTController',
            controllerAs: 'renameSFTController',
            templateUrl: 'shared/smartform/templates/renamesft.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                selected: selected,
                trns: trns
            },
            bindToController: true
        }).then(function (answer) {
            if (answer) {
                $route.reload();
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            }
        });
    };
    
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: this.getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewSmartFormTemplates'
        },
        {
            label: "copy",
            action: this.copyDialog,
            condition: selectedListItems.isSingleSelection,
            process: 'ViewSmartFormTemplates'
        },
        {
            label: "rename",
            action: this.rename,
            condition: selectedListItems.isSingleSelection,
            process: 'ViewSmartFormTemplates'
        }
    ];
    
    this.meta = {
        rowTemplate: 'shared/smartform/templates/sftlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/smartform/list',
        id: "sftlist",
        excelExport: true,
        mainAction : {id:"new", link: "#/sfteditor/0", icon:"mdi-plus"},
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    }
}